enum ParagraphTypeEnum {
  p1_Large = "p1_Large",
  p1_Small = "p1_Small",
  p2_Default = "p2_Default",
  p3_Default = "p3_Default",
  p3_Bold = "p3_Bold",
}

export default ParagraphTypeEnum;
